export const packagesKey = "packages";
export const InventoryKey = "inventory";
export const BillsKey = "bills";
export const subAdminsKey = "subAdmins";
export const subscribersKey = "subscribers";
export const subscriberEmployeeKey = "subscriberEmployee";
export const clientsKey = "clients";
export const designationsKey = "designations";
export const templatesKey = "templates";
export const notificationsKey = "notifications";
export const servicesKey = "services";
export const proformaInvoiceKey = 'proforma-invoice';
export const subscriberSettingsKey = "subscriber-settings";
export const taxCategoryKey = 'tax-category';
export const itemsKey = 'items';
export const transactionsKey = 'transactions';
export const commentsKey = 'comments';
export const subscriberRoleKey = 'subscriber-roles';
export const invoicesKey = 'invoices';
export const ledgerKey = 'ledger';
export const enquiryKey = 'enquiry'
export const categoryKey = 'category'
export const projectKey = 'project'
export const expenseKey = 'expense'
export const projectCommentKey = 'projectComments'
export const paymentKey = 'payment'
export const creditNotesKey = "credit-notes";